import { render, staticRenderFns } from "./referral-info-list-cards.vue?vue&type=template&id=677b9a5d&scoped=true&"
import script from "./referral-info-list-cards.vue?vue&type=script&lang=js&"
export * from "./referral-info-list-cards.vue?vue&type=script&lang=js&"
import style0 from "./referral-info-list-cards.vue?vue&type=style&index=0&id=677b9a5d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b9a5d",
  null
  
)

export default component.exports